import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter()

    const pathFrontEnd = '/editals/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointDelete: `${config.endpoints.backend}editals/delete`,
        endpoint: config.endpoints.backend + 'editals/getall'
    }

    const pathsForm = {
        endpointSave: config.endpoints.backend + 'editals/save',
        endpointGetById: config.endpoints.backend + 'editals/getById',
        endpointGetByEditalNumber: config.endpoints.backend + 'editals/getByEditalNumber',
        endpointGetAllProcesses: config.endpoints.backend + 'processes/getall',
        endpointGetProcessById: config.endpoints.backend + 'processes/getById',
        endpointGetAllEditalDocumentTypes: config.endpoints.backend + 'editaldocumenttypes/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }


    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Editais',
        labelTitleButtonAdd: 'Incluir novo Edital',
        fieldsShowOnDelete: ['edital_number'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'edital_number',
                label: 'Edital',
                width: '15%'
            },
            {
                name: 'project_name',
                label: 'Projeto'
            },
            {
                name: 'object',
                label: 'Objeto'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'edital_number',
                type: 'text',
                mask: '999999/9999',
                label: 'Número do Edital',
                validations: {
                    required: true,
                    edital_number: true
                },
                columnSize: 12
            },
            {
                name: 'pdc_process_id',
                type: 'select',
                label: 'Processo',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProcesses,
                    label: 'process_number',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 6,
            },
            {
                name: 'object',
                type: 'text',
                label: 'Objeto',
                columnSize: 6,
                validations: {
                    required: false,
                },
                readOnly: true
            },
            {
                name: 'files',
                type: 'multiinput',
                label: 'Arquivos do Edital',
                sortBy: 'index',
                form: [
                    {
                        name: 'pdc_edital_document_type_id',
                        type: 'select',
                        label: 'Tipo de Documento',
                        options: [],
                        optionsEndpoint: {
                            endpoint: pathsForm.endpointGetAllEditalDocumentTypes,
                            label: 'name',
                            value: 'id'
                        },
                        validations: {
                            required: true
                        }
                    },
                    {
                        name: 'file',
                        type: 'fileS3',
                        label: 'Arquivo',
                        validations: {
                            required: true
                        }
                    },
                    {
                        name: 'limit_date',
                        type: 'date',
                        label: 'Data Limite',
                        validations: {
                            required: true
                        }
                    }
                ],
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Edital'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
